//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CompetitionTree from '@/components/competition/CompetitionTree'
import competitionApi from '~/api/competition.js'

import { mapState } from 'vuex'

export default {
  name: 'CompetitionStage',
  data() {
    return {
      // 中文数字映射
      chineseNumMap: ['零', '一', '二', '三', '四', '五', '六', '七'],

      // 默认第一轮
      roundActive: 1,
      // 模板
      stageTemp: {
        0: {
          // 战队宽度
          cellWidth: 260,
          // 每一轮的偏移量（向右偏移）
          roundOffset: 142,
          // 基础偏移值
          baseOffset: 71,
        },
        2: {
          // 战队宽度
          cellWidth: 400,
          // 每一轮的偏移量（向右偏移）
          roundOffset: 200,
          // 基础偏移值
          baseOffset: 100,
        },
        3: {
          // 战队宽度
          cellWidth: 260,
          // 每一轮的偏移量（向右偏移）
          roundOffset: 142,
          // 基础偏移值
          baseOffset: 69,
        },
        4: {
          // 战队宽度
          cellWidth: 220,
          // 每一轮的偏移量（向右偏移）
          roundOffset: 80,
          // 基础偏移值
          baseOffset: 40,
        },
        5: {
          // 战队宽度
          cellWidth: 180,
          // 每一轮的偏移量（向右偏移）
          roundOffset: 60,
          // 基础偏移值
          baseOffset: 30,
        },
        6: {
          // 战队宽度
          cellWidth: 180,
          // 每一轮的偏移量（向右偏移）
          roundOffset: 60,
          // 基础偏移值
          baseOffset: 30,
        },
      },
      // 当前赛事数据
      stageData: [],

      // 渲染提示文字
      renderText: '正在渲染赛事...',

      // 开启粘性
      isSticky: false,
    }
  },
  async asyncData({ params, query }) {
    let groupActive = query.group || 'A'
    let { code: groupCode, data: groupData } = await competitionApi.getGroup(
      params.id
    )

    return {
      //默认A组
      groupActive,
      eventId: params.id,
      groupData: groupData ?? [],
    }
  },
  computed: {
    ...mapState({
      passBrowserCheck: (state) => state.app.passBrowserCheck,
    }),
    // 回合数
    roundNum() {
      return this.stageData.length
    },
  },
  methods: {
    /**
     * 获取当前组的数据
     */
    async getGroupData() {
      if (!this.passBrowserCheck) {
        this.renderText = '您的浏览器该升级了'
        return
      }
      const opt = {
        eventId: this.eventId,
        type: 2, // 小组赛
        group: this.groupActive,
      }
      this.stageData = []
      let {
        code: stageCode,
        data: stageData,
      } = await competitionApi.getEventPlan(opt)

      if (stageCode === 0) {
        if (stageData.length === 0) {
          this.renderText = '暂时没有赛程信息'
        }
        this.stageData = stageData
        // this.stageData = [[],[],[],[],[],[]]
      } else if (stageCode === 1) {
        this.renderText = '获取赛程失败，请稍后重试'
      }
    },
    /**
     * 当回合数大于5时
     */
    // TODO 待优化
    roundSwitchEvent(dir) {
      if (dir === 'right') {
        this.roundActive = 6
        this.$refs.roundList.style.transform = `translateX(-239px)`
        this.$refs.stageWrap.style.transform = `translateX(-239px)`

        let $eles2 = document.querySelectorAll('[data-deep="2"]')
        $eles2.forEach((e) => {
          e.querySelector('.line-box').style.display = 'none'
        })

        let $eles5 = document.querySelectorAll('[data-deep="6"]')
        $eles5.forEach((e) => {
          e.querySelector('.line-box').style.display = 'block'
        })
      } else {
        this.roundActive = 1
        this.$refs.roundList.style.transform = `translateX(0)`
        this.$refs.stageWrap.style.transform = `translateX(0)`

        let $eles2 = document.querySelectorAll('[data-deep="2"]')
        $eles2.forEach((e) => {
          e.querySelector('.line-box').style.display = 'block'
        })

        let $eles5 = document.querySelectorAll('[data-deep="6"]')
        $eles5.forEach((e) => {
          e.querySelector('.line-box').style.display = 'none'
        })
      }
    },
    /**
     * 组切换
     */
    switchGroupEvent(groupId) {
      this.groupActive = groupId
      this.$router.push(`${new URL(location.href).pathname}?group=${groupId}`)
      this.getGroupData()
    },
    /**
     * 计算粘性布局
     */
    computeStickyFn() {
      let { top } = this.$refs.stageAll?.getBoundingClientRect()
      if (top <= 0) {
        this.isSticky = true
      } else {
        this.isSticky = false
      }
    },
  },
  components: {
    CompetitionTree,
  },
  activated() {
    if (this.groupActive) {
      this.$router.push(
        `${new URL(location.href).pathname}?group=${this.groupActive}`
      )
    }
    // TODO 祖先元素使用了overflow，无法使用粘性布局
    this.$root.$on('scroll', this.computeStickyFn)
  },
  deactivated() {
    this.$root.$off('scroll', this.computeStickyFn)
  },
  mounted() {
    this.getGroupData()
  },
}
